import { createFrontierBlock, setFrontierBlocksRegistry } from "./createFrontierBlock.esm.js";
import { frontierModules } from "./frontier-modules.esm.js";
const frontierBlocks = {};
setFrontierBlocksRegistry(frontierBlocks);
frontierModules.forEach(([blockName, remoteModule]) => {
  createFrontierBlock(blockName, remoteModule);
});
function initializeMFEs() {
  Object.values(frontierBlocks).forEach((block) => {
    if (block && typeof block.initBlock === "function") {
      block.initBlock();
    }
  });
}
export {
  frontierBlocks,
  initializeMFEs
};
